
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.191 2.347H9.007a.374.374 0 00-.374.373v5.388H2.721a.373.373 0 00-.374.374v10.483c0 .207.167.374.374.374h3.126l2.941 3.11a.373.373 0 00.645-.257l.002-2.853h7.112a.373.373 0 00.374-.374v-5.387h5.27a.374.374 0 00.374-.373V2.72a.374.374 0 00-.374-.373zM16.174 18.59H9.06a.374.374 0 00-.373.374l-.001 2.288-2.408-2.544a.375.375 0 00-.271-.117H3.095V8.856h5.538v4.349c0 .206.168.374.374.374h2.647v2.62a.374.374 0 00.635.267l2.943-2.887h.942v5.012zm5.644-5.76h-6.739a.374.374 0 00-.261.107L12.4 15.309v-2.104a.373.373 0 00-.373-.374H9.38V3.094h12.436v9.737z","fill":"#fff"}})])
          )
        }
      }
    